/**
 * 趣味关系头像
 * */
import React from 'react';
import Util from '../../../script/util';
import './InterestAffinityAvatar.scss';

const InterestAffinityAvatar = ({ data, showName, style }) => {
  return (
    <div className="interest-affinity-avatar-wrap" style={style}>
      <div className="interest-affinity-avatar-left">
        {/* <div className="interest-affinity-avatar-mic">
          {data?.searchMicImage ?
            <img src={Util.transImgUrl(data?.searchMicImage, '50x50')} alt="" />
            : null}
        </div> */}
        <div className="interest-affinity-avatar-tag">
          {data?.searchAppellation}
        </div>
        <img src={Util.transImgUrl(data?.searchAvatar, '50x50')} alt="" />
        {showName ? (
          <div className="interest-affinity-avatar-name">
            {data?.searchNickName}
          </div>
        ) : null}
      </div>
      <div className="interest-affinity-avatar-center"></div>
      <div className="interest-affinity-avatar-right">
        {/* <div className="interest-affinity-avatar-mic">
          {data?.otherMicImage ?
            <img src={Util.transImgUrl(data?.otherMicImage, '50x50')} alt="" />
            : null}
        </div> */}
        <div className="interest-affinity-avatar-tag">
          {data?.otherAppellation}
        </div>
        <img src={Util.transImgUrl(data?.otherAvatar, '50x50')} alt="" />
        {showName ? (
          <div className="interest-affinity-avatar-name">
            {data?.otherNickName}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default InterestAffinityAvatar;
